import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import validator from 'validator';
import PropTypes from "prop-types";
import _ from "lodash";
import { Form, Button, Modal } from "semantic-ui-react";
import FormErrorMessage from "../../utils/FormErrorMessage";
import { updateAddressModelInStore, updateOrCreateAddress } from "../../../actions/relation";
import Dls from "../../../lib";

class AddressModalForm extends Component {
    constructor() {
        super();
        this.state = {
            errors: [],
            loading: false
        };
    }

    onFormSubmit = () => {
        const errors = this.validateInput();
        if (_.isEmpty(errors)) {
            this.setState({
                loading: true
            });
            this.props
                .updateOrCreateAddress(this.props.jwt, this.props.model)
                .then(res => {
                    this.setState({
                        loading: false
                    })
                })
                .catch(err => {
                    const errors = Dls.apiErrorMessage(err);
                    this.setState({
                        loading: false,
                        errors: errors
                    });
                });
        } else {
            this.setState({
                errors: errors
            });
        }
    };

    validateInput = () => {
        const { label, email } = this.props.model;
        const errors = [];
        if (!label) {
            errors.push("Label field is required");
        }
        if (email) {
            if (!validator.isEmail(email)) {
                errors.push("Eamil address is invalid");
            }
        }
        return errors;
    };
    
    render() {
        const {model, updateAddressModelInStore, isDirty, isOpen} = this.props
        return (
            <Modal
                open={isOpen}
                dimmer='blurring'
                closeOnEscape={true}
                closeOnDimmerClick={false}
                onClose={() => {this.props.onModalClose()}}
                size='tiny'
            >
                <Modal.Header>Manage Address</Modal.Header>
                <Modal.Content>
                    <Form size="mini">
                        {!_.isEmpty(this.state.errors) ? (
                            <FormErrorMessage errors={this.state.errors} />
                        ) : null}
                            <Form.Input 
                                fluid 
                                label="label"
                                name="label"
                                value={model.label ? model.label : ""} 
                                onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                            />
                            <Form.Select fluid label='Status' options={[
                                    {key: 'Active', text: 'Active', value: 'Active'},
                                    {key: 'Disabled', text: 'Disabled', value: 'Disabled'}
                                ]} name="status" value={model.status ? model.status : "Active"} 
                                onChange={(e,data) => { updateAddressModelInStore('status', data.value) }}
                            />
                            <Form.Input 
                                fluid 
                                label="Company Name"
                                name="company"
                                value={model.company ? model.company : ""} 
                                onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                            />
                            <Form.Group unstackable widths={2}>
                            <Form.Input 
                                fluid 
                                label="First Name"
                                name="first_name"
                                value={model.first_name ? model.first_name : ""} 
                                onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                            />
                            <Form.Input 
                                fluid 
                                label="Last Name"
                                name="last_name"
                                value={model.last_name ? model.last_name : ""} 
                                onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                            />
                            </Form.Group>
                            <Form.Group unstackable widths={2}>
                                <Form.Input 
                                    fluid 
                                    label="Email"
                                    name="email"
                                    value={model.email ? model.email : ""} 
                                    onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Phone"
                                    name="phone"
                                    value={model.phone ? model.phone : ""} 
                                    onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                                />
                            </Form.Group>
                            <Form.Group unstackable widths={2}>
                                <Form.Input 
                                    fluid 
                                    label="Address 1"
                                    name="address_1"
                                    value={model.address_1 ? model.address_1 : ""} 
                                    onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Address 2"
                                    name="address_2"
                                    value={model.address_2 ? model.address_2 : ""} 
                                    onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                                />
                            </Form.Group>
                            <Form.Group unstackable widths={2}>
                                <Form.Input 
                                    fluid 
                                    label="City"
                                    name="city"
                                    value={model.city ? model.city : ""} 
                                    onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Postal Code"
                                    name="postcode"
                                    value={model.postcode ? model.postcode : ""} 
                                    onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                                />
                            </Form.Group>
                            <Form.Group unstackable widths={2}>
                                <Form.Input 
                                    fluid 
                                    label="State / Province"
                                    name="state"
                                    value={model.state ? model.state : ""} 
                                    onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Country"
                                    name="country"
                                    value={model.country ? model.country : ""} 
                                    onChange={(e) => { updateAddressModelInStore(e.target.name, e.target.value) }}
                                />
                            </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <div className="row">
                        <div className="col-md-12">
                            <Button onClick={() => {this.props.onModalClose()}} color="red" floated='left' size='mini'>
                                Close
                            </Button>
                            <Button
                                color="teal"
                                onClick={this.onFormSubmit}
                                loading={this.state.loading}
                                disabled={!isDirty}
                                floated='right'
                                size='mini'
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                </Modal.Actions>
            </Modal>
        );
    }
}

AddressModalForm.propTypes = {
    updateOrCreateAddress: PropTypes.func.isRequired,
    updateAddressModelInStore: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    isDirty: PropTypes.bool.isRequired,
    jwt: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        model: state.address.model,
        isDirty: state.address.dirty,
        jwt: state.auth.jwt
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateAddressModelInStore, updateOrCreateAddress
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddressModalForm);



// WEBPACK FOOTER //
// ./src/components/forms/relations/AddressModal.js